import React from "react";

interface FlagProps {
  className?: string;
}

export const BrazilFlag: React.FC<FlagProps> = ({ className = "w-6 h-6" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 512 512" 
    className={className}
  >
    <rect width="512" height="512" fill="#009b3a" />
    <polygon points="256,48 488,256 256,464 24,256" fill="#fedf00" />
    <circle cx="256" cy="256" r="90" fill="#002776" />
    <path
      d="M166,256 Q256,190 346,256"
      fill="none"
      stroke="#fff"
      strokeWidth="12"
    />
  </svg>
);

export const USAFlag: React.FC<FlagProps> = ({ className = "w-6 h-6" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 512 512" 
    className={className}
  >
    <rect width="512" height="512" fill="#fff" />
    <g fill="#bf0a30">
      <rect y="39.4" width="512" height="39.4" />
      <rect y="118.2" width="512" height="39.4" />
      <rect y="197" width="512" height="39.4" />
      <rect y="275.8" width="512" height="39.4" />
      <rect y="354.6" width="512" height="39.4" />
      <rect y="433.4" width="512" height="39.4" />
    </g>
    <rect width="204.8" height="275.7" fill="#002868" />
    <g fill="#fff">
      <circle cx="17" cy="23" r="8" />
      <circle cx="51" cy="23" r="8" />
      <circle cx="85" cy="23" r="8" />
      <circle cx="119" cy="23" r="8" />
      <circle cx="153" cy="23" r="8" />
      <circle cx="187" cy="23" r="8" />
      <circle cx="34" cy="46" r="8" />
      <circle cx="68" cy="46" r="8" />
      <circle cx="102" cy="46" r="8" />
      <circle cx="136" cy="46" r="8" />
      <circle cx="170" cy="46" r="8" />
      <circle cx="17" cy="69" r="8" />
      <circle cx="51" cy="69" r="8" />
      <circle cx="85" cy="69" r="8" />
      <circle cx="119" cy="69" r="8" />
      <circle cx="153" cy="69" r="8" />
      <circle cx="187" cy="69" r="8" />
      <circle cx="34" cy="92" r="8" />
      <circle cx="68" cy="92" r="8" />
      <circle cx="102" cy="92" r="8" />
      <circle cx="136" cy="92" r="8" />
      <circle cx="170" cy="92" r="8" />
      <circle cx="17" cy="115" r="8" />
      <circle cx="51" cy="115" r="8" />
      <circle cx="85" cy="115" r="8" />
      <circle cx="119" cy="115" r="8" />
      <circle cx="153" cy="115" r="8" />
      <circle cx="187" cy="115" r="8" />
      <circle cx="34" cy="138" r="8" />
      <circle cx="68" cy="138" r="8" />
      <circle cx="102" cy="138" r="8" />
      <circle cx="136" cy="138" r="8" />
      <circle cx="170" cy="138" r="8" />
      <circle cx="17" cy="161" r="8" />
      <circle cx="51" cy="161" r="8" />
      <circle cx="85" cy="161" r="8" />
      <circle cx="119" cy="161" r="8" />
      <circle cx="153" cy="161" r="8" />
      <circle cx="187" cy="161" r="8" />
      <circle cx="34" cy="184" r="8" />
      <circle cx="68" cy="184" r="8" />
      <circle cx="102" cy="184" r="8" />
      <circle cx="136" cy="184" r="8" />
      <circle cx="170" cy="184" r="8" />
      <circle cx="17" cy="207" r="8" />
      <circle cx="51" cy="207" r="8" />
      <circle cx="85" cy="207" r="8" />
      <circle cx="119" cy="207" r="8" />
      <circle cx="153" cy="207" r="8" />
      <circle cx="187" cy="207" r="8" />
    </g>
  </svg>
);
